
// convert a number to "-" when its null or 0
export default {
	name: 'ZeroNullValue',
	handler: {
		init: function (element, valueAccessor, allBindingsAccessor) {
			let value = valueAccessor();
			// let allBindings = allBindingsAccessor();

			let valueUnwrapped = ko.utils.unwrapObservable(value);

			if (valueUnwrapped === 0 || valueUnwrapped === null || valueUnwrapped === undefined)
				$(element).text('-');
			else
				$(element).text(valueUnwrapped);
		}
	}
};
